export default "__VITE_ASSET__a35503c1__"